import { ChangeEvent } from 'react'
import { DropdownProps } from 'semantic-ui-react'
import classNames from 'classnames'

import { Form } from 'client/semantic-imports'
import { AppFormFieldLabel } from 'client/ui-building-blocks'

import { Position } from '../types'

import classes from '../classes.module.scss'
import './app-form-select.scss'

type AppFormSelectProps = {
  label?: string
  placeholder?: string
  value: string
  options: { value: string; text: string }[]
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
  error?: string
  position?: Position
  disabled?: boolean
  loading?: boolean
}

const AppFormSelect = (props: AppFormSelectProps) => {
  const {
    label = '',
    placeholder = '',
    value,
    options,
    onChange,
    error = '',
    position = 'left',
    disabled = false,
    loading = false,
  } = props

  return (
    <div
      data-testid="app-form-select"
      className={classNames('appFormSelect', classes[position])}
    >
      <Form.Dropdown
        label={label ? <AppFormFieldLabel label={label} error={error} /> : undefined}
        placeholder={loading ? 'Loading ...' : placeholder}
        value={value}
        options={options}
        onChange={(e: ChangeEvent<HTMLInputElement>, data: DropdownProps) => {
          e.target.value = String(data.value)
          onChange(e)
        }}
        selection
        disabled={disabled || loading}
        loading={loading}
        selectOnBlur={false}
      />
    </div>
  )
}

export default AppFormSelect
